<template>
  <component :is="tag" :class="[classes.text, testClassName]">
    <slot />
  </component>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { defineComponent, computed, PropType } from "vue";
import { FontStyle, injectBrand } from "@fresh8/ad-data-composition/src/brand";

const { useStyles } = createUseStyles<"text", FontStyle>({
  text: props => {
    const {
      fontFamily,
      fontStyle,
      color,
      textTransform,
      textDecoration
    } = props;
    return {
      fontFamily,
      fontStyle,
      color,
      textTransform,
      textDecoration
    };
  }
});

export default defineComponent({
  name: "StyledText",
  props: {
    tag: {
      type: String as PropType<"p" | "span">,
      required: false,
      default: "p"
    },
    fontId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: false,
      default: ""
    }
  },
  setup(props) {
    const { getFontStyle } = injectBrand();

    const reactiveStyles = computed(() => getFontStyle(props.fontId));
    const { classes } = useStyles(reactiveStyles);

    return {
      classes,
      testClassName: computed(
        () =>
          "text-style-" +
          props.name
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/[^A-z-]/g, "")
      )
    };
  }
});
</script>
